<template>
    <div class="bg-box grid grid-cols-2 row-gap-2 col-gap-2 text-white p-4 rounded-md w-5/6">

        <div class="bg-module rounded-md p-2 flex flex-col" v-for="(rec, idx, key) in records" :key="idx">
            <div class="flex justify-between ">
                <div v-if="key === 0" class="text-font-gray">Ayer</div>
                <div v-else-if="key === 1" class="text-font-gray">Hace una semana</div>
                <div v-else-if="key === 2" class="text-font-gray">Hace un año</div>
                <div v-else class="text-font-gray">Récord <StarIcon class="text-warning"/></div>
                <div class="text-font-gray">{{rec.date}}</div>
            </div>
                        
            <div v-if="idx !== 'record'" class="flex justify-evenly  my-auto">
                <div class="mr-1 text-lg">{{rec.amount_now | numberFormat(2)}}€</div>
                <div class="text-success-30 mt-1">{{rec.orders}}<ShopIcon class="ml-1 text-success"/></div>
            </div>

            <div v-if="idx === 'record'" class="flex justify-evenly my-auto">
                <div class="mr-1 text-lg">{{rec.record_amount | numberFormat(2)}}€</div>
                <div class="text-success-30 mt-1">{{rec.orders}}<ShopIcon class="ml-1 text-success"/></div>
            </div>
            <SalesBar :data="rec.percent" />
        </div> 
    </div>  
</template>

<script>
import ShopIcon from '@/components/icons/ShopIcon.vue'
import StarIcon from '@/components/icons/StarIcon.vue'
import SalesBar from '@/components/SalesBar.vue'

    export default {
        name: 'salesRecords',

        props: {
            records: {
                type: Object,
                required: true
            }
        },

        components: {
            ShopIcon,
            StarIcon,
            SalesBar
        }
    }


</script>

<style>
</style>